"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const alliances = [{
  name: "NVIDIA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/nvidia_partner_logo.png"
}, {
  name: "Vertiv",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/vertiv_partner_logo.png"
}, {
  name: "Schneider Electric",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/schneider_partner_logo.png"
}, {
  name: "ABB",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/abb_partner_logo.png"
}, {
  name: "Siemens",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/siemens_partner_logo.png"
}, {
  name: "Eaton",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/eaton_partner_logo.png"
}, {
  name: "Arista",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/arista_partner_logo.png"
}, {
  name: "Equinix",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/equinix_partner_logo.png"
}];
export default function StrategicAlliances() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="139081" id="grid-trust-signals" className="dark bg-background text-foreground py-24 lg:py-32 overflow-hidden border-y border-border/20 relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`mb-16 md:mb-24 flex flex-col items-center justify-center transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-xs font-mono tracking-[0.4em] uppercase text-muted-foreground/80">
            Technical Interoperability
          </h2>
          <div className="mt-6 h-px w-16 bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
        </div>

        <div ref={gridRef} className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-16 items-center justify-items-center transition-all duration-1000 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {alliances.map((partner, i) => <div key={partner.name} data-index={i} className="group relative flex h-32 w-full max-w-[200px] items-center justify-center p-6 transition-all duration-500 cursor-default">
              {}
              <div className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] blur-2xl mix-blend-screen pointer-events-none" />
              
              <img src={partner.logo} alt={`${partner.name} logo`} className="relative z-10 max-h-12 w-auto object-contain filter grayscale opacity-30 transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:drop-shadow-[0_0_20px_var(--color-primary)] group-hover:scale-105" />
            </div>)}
        </div>
      </div>
    </section>;
}